import commonUtil from '../../utils/commonUtil';

export const getFAQ = (page) => {
  const data = {
    brand: commonUtil.getBrand(),
    channel: commonUtil.getChannel(),
    page,
  };
  return commonUtil.triggerServerRequest({
    url: '/api/FAQ?' + commonUtil.objectToQueryParams(data),
    method: 'GET',
    data,
  });
};
